<script type="module" lang="ts">
	export let primary: boolean = false;
  export let url: string = null;
</script>

{#if primary}
	<a href="{url}" data-sveltekit-preload-data>
		<div class="rounded-full bg-red-600 py-2 text-center drop-shadow-sm">
			<p class="text-white"><slot /></p>
		</div>
	</a>
{:else}
	<a href="{url}" data-sveltekit-preload-data>
		<div class="rounded-full border-[1px] border-red-600 py-2 text-center drop-shadow-sm">
			<p class="text-red-600"><slot /></p>
		</div>
	</a>
{/if}
